import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAilL9nJ8HxbsARFnwLQkRcN-rb0g-H5wg",
  authDomain: "salesguru-86316.firebaseapp.com",
  projectId: "salesguru-86316",
  storageBucket: "salesguru-86316.firebasestorage.app",
  messagingSenderId: "808622255984",
  appId: "1:808622255984:web:76809a019e7852dc6d29b5"
};

console.log('[Firebase] Initializing Firebase app with project:', firebaseConfig.projectId);
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Set persistence to local (default) to maintain auth state across page refreshes
setPersistence(auth, browserLocalPersistence).then(() => {
  console.log('[Firebase] Auth persistence set to LOCAL');
}).catch((error) => {
  console.error('[Firebase] Error setting auth persistence:', error);
});

// Log current auth state
auth.onAuthStateChanged((user) => {
  console.log('[Firebase] Global auth state changed');
});

console.log('[Firebase] Firebase initialized successfully');

export default app;